import { memo, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useRoles } from 'utils/hooks'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { IS_PRODUCTION, BASE_URL } from 'utils/constants'
import { GENERAL_ERROR } from 'api/constants'
import * as PAGES from 'containers'
import NotFoundPage from 'containers/NotFoundPage/Loadable'
import DeactivatedUserPage from 'containers/DeactivatedUserPage/Loadable'
import CallbackPage from 'containers/CallbackPage/Loadable'
import CallbackOAuthPage from 'containers/CallbackOAuthPage/Loadable'
import { flatNav } from './navigation'
import { useAuth0 } from '@auth0/auth0-react'

const AppRoutes = () => {
  const dispatch = useDispatch()
  const roles = useRoles()
  const user = useSelector(({ global }) => global.user)
  const isDeactivated = !user ? false : user?.is_wallet_capable ? user?.savings_account_status === 6 && !user?.is_active : !user?.is_active
  const { isAuthenticated, loginWithRedirect, isLoading } = useAuth0()

  const handleOnError = useCallback((error, errorInfo) => {
    dispatch({ 
      type: GENERAL_ERROR,
      error_stack: `Page: ${window.location.href}\n\nError: ${JSON.stringify(error, Object.getOwnPropertyNames(error))}`,
    })
  }, [])

  if (!isAuthenticated) {
    window.sessionStorage?.setItem('redirect', window.location.pathname + window.location.search)
    loginWithRedirect({
      redirectUri: `${BASE_URL}/callback`,
    })
    return null
  }

  return (
    <Routes>
      {flatNav.map((navItem, idx) => {
        const Element = PAGES[navItem.component]

        if (
          Element &&
          !!user?.unique_id &&
          (navItem.dev ? !IS_PRODUCTION : true)
        ) {
          return (
            <Route
              key={navItem.path}
              path={navItem.path}
              element={
                isDeactivated ?
                <Navigate to="/deactivated-user" replace /> :
                navItem.redirect ? 
                <Navigate to={navItem.redirect} replace /> : 
                navItem.roles && !roles.hasRole(navItem.roles) ? 
                <Navigate to="/" replace /> : 
                <Element onError={handleOnError} />
              }
            />
          )
        }
      })}
      <Route path="/callback" element={<CallbackPage />} />
      <Route path="/external_account_callback" element={<CallbackOAuthPage />} />
      <Route path="/deactivated-user" element={<DeactivatedUserPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default memo(AppRoutes)